import { useMemo } from 'react'
import { motion } from 'framer-motion'
import LinkCard from './LinkCard'

const CATEGORY_ORDER = ['Code & Writing', 'Academic & Research', 'Professional & Social']

export default function LinksDirectory({ links, loading }) {
    const groups = useMemo(() => {
        const map = new Map()
        for (const item of links) {
            const cat = item?.category && CATEGORY_ORDER.includes(item.category) ? item.category : 'Other'
            if (!map.has(cat)) map.set(cat, [])
            map.get(cat).push(item)
        }

        const ordered = CATEGORY_ORDER.filter((cat) => map.has(cat)).map((cat) => [cat, map.get(cat)])
        if (map.has('Other')) ordered.push(['Other', map.get('Other')])
        return ordered
    }, [links])

    if (loading) {
        return (
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                {Array.from({ length: 6 }).map((_, i) => (
                    <motion.div key={i} className="h-32 bg-zinc-100 dark:bg-zinc-900 animate-pulse" initial={{ opacity: 0.5 }} animate={{ opacity: 1 }} transition={{ repeat: Infinity, duration: 1 }} />
                ))}
            </div>
        )
    }

    if (groups.length === 0) {
        return (
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="text-center py-12 text-zinc-600 dark:text-zinc-300">
                <p className="text-lg font-medium">No links available yet.</p>
            </motion.div>
        )
    }

    return (
        <div className="space-y-8">
            {groups.map(([cat, items], idx) => (
                <motion.section key={cat} initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: idx * 0.05 }}>
                    <h3 className="mb-3 font-serif text-lg font-bold text-black dark:text-white">
                        {cat} <span className="ml-1 font-mono text-xs font-normal text-zinc-500 dark:text-zinc-400">({items.length})</span>
                    </h3>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                        {items.map((item) => (
                            <LinkCard key={item._key || item.link} item={item} />
                        ))}
                    </div>
                </motion.section>
            ))}
        </div>
    )
}
